import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

import { BrowserOnly } from '@core/data-providers/platform/platform.decorators';
import { CommonWindow } from '@core/domain/models/common-window.model';

@Injectable({
    providedIn: 'root',
})

/**
 * Servicio para obtener información sobre el dispositivo del cliente
 */
export class DeviceService {
    constructor(
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    /**
     * Función para saber si el dispositivo es un movil
     * @deprecated Este método está obsoleto. En su lugar usaremos
     * this.store.select(getResolution)
     * Usamos un selector REDUX y no una función porque un dispositivo
     * puede cambiar de resolución: Ej, se gira el móvil.
     * Así que no se debe usar un take1 o first junto con
     * getResolution ( salvo que lo consideremos oportuno)
     */
    @BrowserOnly<DeviceService, boolean>(false)
    public isMobile(): boolean {
        if (this.isDeviceMobile()) {
            return true;
        }
        return !this.window.matchMedia('(min-width: 1280px)').matches;
    }

    private isDeviceMobile() {
        return (
            /ipad/i.exec(navigator.userAgent)
            || /iphone/i.exec(navigator.userAgent)
            || /android/i.exec(navigator.userAgent)
            || /webos/i.exec(navigator.userAgent)
            || /ipod/i.exec(navigator.userAgent)
            || /blackberry/i.exec(navigator.userAgent)
            || /windows phone/i.exec(navigator.userAgent)
            || /symbianos/i.exec(navigator.userAgent)
        );
    }

    /*
    * Esta función solo se usara en funciones STATIC
    * para lo demás se usara "platform" que angular ofrece.
    * */
    public static getBrowserWithoutInjectPlatform(window: CommonWindow): string {
        const userAgent = window.navigator.userAgent.toLowerCase();

        if (userAgent.includes('opera') || userAgent.toLowerCase().includes('opr')) {
            return 'opera';
        }
        if (userAgent.includes('edg')) {
            return 'edge';
        }
        if (userAgent.includes('chrome')) {
            return 'chrome';
        }
        if (userAgent.includes('safari')) {
            return 'safari';
        }
        if (userAgent.includes('firefox')) {
            return 'firefox';
        }
        return 'generic';
    }
}
